class CardSwatches extends HTMLElement {
  connectedCallback() {
    this.cardWrapper = this.closest('.card-wrapper');
    this.cardImage = this.cardWrapper.querySelector('[data-card-image]');
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const swatch = event.target.closest('.card__swatch');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const newImageUrl = swatch.dataset.swatchImage;
    if (!newImageUrl || !this.cardImage) return;

    this.cardImage.src = newImageUrl;
    this.cardImage.srcset = '';

    this.setActive(swatch);
  }

  setActive(swatch) {
    this.clearActive();
    swatch.setAttribute('data-active', '');
  }

  clearActive() {
    this.querySelectorAll('[data-active]').forEach((s) => s.removeAttribute('data-active'));
  }
}

customElements.define('card-swatches', CardSwatches);
